import i18n from '@/lang/i18n'

export default function() {
    return [
        {
            type: 'customCheckbox'
        },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.name'),
            colId: 'description',
            field: 'description',
            minWidth: 380
        },
        {
            type: 'checkIconRenderer',
            headerName: i18n.t('configuration.grid.active'),
            colId: 'active',
            field: 'active',
            flex: 2
        }
    ]
}
